<template>
    <div>
        <colapse label="Content">
            <b-button class="mg-v-20" @click="addLink()"> add link
            </b-button>
            <draggable :list="links" handle=".handle" @end="saveLinkChange">
                <LinkEditor v-for="(link,ind) in links" v-bind:key="`le-${ind}`" :link="link"
                    @icon-click='OpenIconSearchModal(link)' />
            </draggable>
        </colapse>
        <icon-search-modal @close='isIconModalActive = false' 
            :link="selectedLink"
            :isActive="isIconModalActive"/> 
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import Colapse from '@/components/containers/Colapse.vue'
    import draggable from 'vuedraggable'
    import LinkEditor from "@/components/LinkEditor"
    import IconSearchModal from "@/components/modals/IconSearchModal.vue"

    
    export default {
        components:{
            Colapse,
            draggable,
            LinkEditor,
            IconSearchModal,
        },
        computed:{
            ...mapGetters([
                'links'
                ]),  
        },
        data(){
            return{
                
                isIconModalActive:false,
                selectedLink:{},
            }
        },
        methods:{
            ...mapMutations([
                'addLink',
            ]),
            ...mapActions([
                'saveLinkChange',
                ]),   
            OpenIconSearchModal(link) {
                this.selectedLink = link
                this.isIconModalActive = true;
            },
        }
    }
</script>

<style>

</style>